export const positions = { C: 'Center', F: 'Forward', PF: 'Forward', G: 'Guard', PG: 'Guard' };
